import { render, staticRenderFns } from "./AdministrativeCentersFB2B.vue?vue&type=template&id=137b394c"
import script from "./AdministrativeCentersFB2B.vue?vue&type=script&lang=js"
export * from "./AdministrativeCentersFB2B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports